<template>
  <div>
    <title>兑换礼品券规格管理</title>
    <section class="goodsDet">
      <!--S 公用头部切换-->
      <GoodsGiftInfoTab :active="currentTit"></GoodsGiftInfoTab>
      <!--E 公用头部切换-->

      <!--S 规格列表-->
      <SpecsKind @editKindInfo="editKindInfo" :againTrue="isAgain" :goodsType="1"></SpecsKind>
      <!--E 规格列表-->

      <!--S 规格表单-->
      <section class="specFormWrap">
        <el-form :model="specfyForm" :label-width="(ElementControls('Goods_Pickupcard')==1 || ElementControls('Combo_Pickupcard')==1 || ElementControls('Quota_Pickupcard')==1) ?'150px':'130px'"
          class="comForm goodsWrap"
          :disabled="kindTabName=='详情' || (ElementControls('Goods_Pickupcard')!=1&&kindDetail.cardcategory===0)">
          <h3 class="specTit">
            <span>{{kindTabName}}</span>
            <!-- <span>详情</span>
            <span>编辑</span> -->
          </h3>
          <el-row class="goodsWrap">
            <!--S 基础设置-->
            <el-col :span="11">
              <!-- 规格基础设置组件 S -->
              <SetKindInfo :goodsType="1" :kindTabName="kindTabName" :againTrue="isAgain" :isReset="kindTabName=='新增'?true:false" :isBesale="goodsKind.besale" :kindInfoValue="kindDetail" :isOpenFe="postagefree"></SetKindInfo>
              <!-- 规格基础设置组件 E -->
            </el-col>
            <!--E 基础设置-->
            <el-col :span="2"></el-col>
            <!--S 用途设置 + 销售渠道-->
            <el-col :span="11">
              <div class="grid-content useSetting">
                <p class="commonTit"><b>用途设置</b></p>
                <el-form-item>
                  <el-checkbox-group v-model="specfyForm.supplyfor">
                    <el-checkbox v-for="(item,index) in supplyforLists" :label="item.value"
                      :key="index">{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                  <em class="iconbulb breathTit">赠品不在商城显示</em>
                </el-form-item>
              </div>
              <!-- S 库存设置组件 -->
              <CardGoodsStock :againTrue="isAgain" :isReset="kindTabName=='新增'?true:false" :stockShow="pinvcontrol"
                :kindcode="kindDetail.kindcode?kindDetail.kindcode:''" v-if="baseInvcontrol"></CardGoodsStock>
              <!-- E 库存设置组件 -->
              <!-- 兑换礼券销售渠道组件 S -->
              <CardSaleCanal :againTrue="isAgain" :isReset="kindTabName=='新增'?true:false"
                :kindcode="kindDetail?kindDetail.kindcode:''"></CardSaleCanal>
              <!-- 兑换礼券销售渠道组件 S -->
            </el-col>
            <!--E 用途设置 + 销售渠道-->
          </el-row>   
          <p class="commonTit"><b>券卡规则</b></p>
          <!-- S 券卡规则组件 -->
          <ModifyCardRule :exchangemode="exchangemode" :againTrue="isAgain" useType="商品" :kindTabName="kindTabName" cateType="1"
            :kindInfoValue="kindDetail" :isReset="kindTabName=='新增'?true:false"></ModifyCardRule>
          <!-- E 券卡规则组件 -->
        </el-form>
      </section>
      <!--E 规格表单-->
      <div class="bottomBtn">
        <el-button type="primary" @click="subKindInfo"
          v-if="kindTabName!='详情'&&(ElementControls('Goods_Pickupcard')==1||(ElementControls('Goods_Pickupcard')!=1&&kindDetail.cardcategory!==0))">提交</el-button>
        <el-button @click="goList">返回列表</el-button>
      </div>
    </section>

    <!--============================= S 弹框 =============================-->
  </div>
</template>
<script>
  import { MessageBox } from "element-ui";
  import api from '../../../apis/api.js'
  import { mapState, mapActions } from "vuex";
  import Vue from 'vue'
  export default {
    name: 'GoodsSpecifyMange',
    // ==================================== 组件====================================
    components: {
      GoodsGiftInfoTab: resolve => require(["@/components/GoodsFolder/GoodsGiftInfoTab.vue"], resolve),
      Page: resolve => require(["@/components/common/Page.vue"], resolve),
      SpecialGoodsOper: resolve =>
        require(["@/components/common/SpecialGoodsOper.vue"], resolve), // 可操作专区商品
      SpecsKind: resolve => require(["@/components/GoodsFolder/SpecsKind.vue"], resolve), // 规格列表组件
      ModifyCardRule: resolve => require(["@/components/CardsFolder/ModifyCardRule.vue"], resolve), // 券卡规则组件
      SetKindInfo: resolve => require(["@/components/GoodsFolder/SetKindInfo.vue"], resolve), // 规格基础信息组件
      CardSaleCanal: resolve => require(["@/components/GoodsFolder/CardSaleCanal.vue"], resolve), // 兑换礼券销售渠道组件
      CardGoodsStock: resolve => require(["@/components/GoodsFolder/CardGoodsStock.vue"], resolve), // 兑换/消费卡库存组件
    },
    // ==================================== 变量====================================
    data() {
      return {
        goodsInv: false, // 规格详情时是否调用库存接口
        pinvcontrol: false, // 是否控制库存
        isAgain: false, // 列表是否重新加载
        kindTabName: '新增', // 规格操作的头部名称
        kindCode: '', // 查看或编辑的规格编号
        goodsCode: '', // 商品编号
        kindDetail: '', // 获取到的规格信息
        goodsKind: '', // 保存的上级商品信息
        currentTit: 1, //当前选中菜单
        supplyforLists: [ //用途设置
          { label: '用于推荐', value: '0' },
          { label: '作为赠品', value: '1' }
        ],
        //规格表单变量
        specfyForm: {
          supplyfor: [], // 商品用途。0：用于推荐；1：作为赠品；2：参与仓分享
          specImgUrl: '', // 图片
        },
        goodsChoseDialogVisible: false, //选择可选商品弹框
        goodsNum: 1, //可选商品数量
        postagefree: 1, // 商品是否包邮
        baseInvcontrol: 0, // 商家是否开通库存
        bpinkage: 1, // 商家是否包邮
        firstTrue: true, // 防止多次点击提交
        exchangemode: 0, // 拆单形式 默认0 0：传统拆单；1：按次数拆单；
      }
    },
    filters: {

    },

    // ============================================== 监听 ==============================================
    watch: {
    },
    // ============================================== 计算属性 ==========================================
    computed: {
      ...mapState({
        kindInfo: ({ goodsStore }) => goodsStore.kindInfo, // 规格上传基础信息
        channelInfo: ({ goodsStore }) => goodsStore.channelInfo, // 规格销售渠道信息
        cardRule: ({ common }) => common.cardRule, // 券卡规则
        stockInfo: ({ goodsStore }) => goodsStore.stockInfo, // 规格库存信息
      })
    },
    // ============================================== 方法 ==============================================
    methods: {
      ...mapActions(["areaArrayStore"]),
      // 返回商品列表
      goList() {
        this.$router.push({
          name: '兑换礼品券'
        })
      },
      // 编辑或查看规格详情
      editKindInfo(code, name) {
        this.kindCode = code;
        this.kindTabName = name;
        if (name == '新增') {
          this.kindDetail = '';
          this.clearData();
        } else {
          this.getKindDetail();
        }
      },
      // 清空表单数据
      clearData() {
        this.specfyForm.supplyfor = [];
        this.areaArrayStore({ deleteTrue: true })
        // this.channelInfo = []; // 取于状态管理器，销售渠道
      },
      // 获取规格详情信息
      getKindDetail() {
        api.KINDINFODETAIL({ kindcode: this.kindCode }).then(res => {
          if (res.data.status == "200") {
            this.kindDetail = res.data.data;
            if (this.kindDetail.bexpresalegoods) { // 是否用于推荐
              this.specfyForm.supplyfor.push('0')
            }
            if (this.kindDetail.isgift) { // 是否用于赠品
              this.specfyForm.supplyfor.push('1')
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      },

      // 打开选择可选商品弹窗
      getShowChoseGoods() {
        this.goodsChoseDialogVisible = true;
      },
      // 关闭选择可选商品弹窗
      getCloseGoodsCld() {
        this.goodsChoseDialogVisible = false;
      },
      // 提交规格信息
      subKindInfo() {
        if (this.firstTrue) {
          // if(!this.postagefree&&!this.bpinkage) {
          //   if(!this.kindInfo.postageWeight) {
          //     this.$message({
          //       type: 'error',
          //       message: '邮费计重不能为空!'
          //     });
          //     return false
          //   } else if(this.kindInfo.postageWeight == 0) {
          //     this.$message({
          //       type: 'error',
          //       message: '邮费计重不能小于0!'
          //     });
          //     return false
          //   }
          // };
          if (!this.kindInfo.goodsprice) {
            this.$message({
              type: 'error',
              message: '原售价不能为空!'
            });
            return false
          };
          if (!this.kindInfo.goodsmallprice) {
            this.$message({
              type: 'error',
              message: '商品一口价不能为空!'
            });
            return false
          };
          if (!this.kindInfo.directprice && this.ElementControls('jinshizun') == 1 && this.ElementControls('saleordercontrprice') == 1) {
            this.$message({
              type: 'error',
              message: '直客销售控价不能为空!'
            });
            return false
          };
          if (!this.kindInfo.channelprice && this.ElementControls('jinshizun') == 1 && this.ElementControls('saleordercontrprice') == 1) {
            this.$message({
              type: 'error',
              message: '渠道销售控价不能为空!'
            });
            return false
          };
          if (!this.kindInfo.electsmallprice && this.goodsKind.besale != 0) {
            this.$message({
              type: 'error',
              message: '电子券价格不能为空!'
            });
            return false
          };
          if (!this.kindInfo.bsale && this.kindInfo.unshelvememo === '') {
            this.$message({
              type: 'error',
              message: '下架备注不能为空!'
            });
            return false
          };
          if (this.pinvcontrol && this.stockInfo.saleinv === '' && this.kindTabName == '新增') {
            this.$message({
              type: 'error',
              message: '商城销售库存不能为空!'
            });
            return false
          };
          if (this.ElementControls('Goods_Pickupcard') == 1 && this.cardRule.cardcategory) {
            if (!this.cardRule.areainfo[0].listnum) {
              this.$message({
                type: 'error',
                message: '可选择商品数量不能小于1!'
              });
              return false
            }
          } else {
            if (!this.cardRule.tcCardcategory && !this.cardRule.deCardcategory) {
              if (this.cardRule.areainfo.length == 1) {
                if (this.cardRule.areainfo[0].listnum < this.cardRule.areainfo[0].zoneselnum) {
                  this.$message({
                    type: 'error',
                    message: '专区供选择商品数量不能小于可选择商品数量!'
                  });
                  return false
                }
              } else {
                let areaGoodsNum = 0;
                this.cardRule.areainfo.some(item => {
                  areaGoodsNum += item.zoneselnum
                })
                if (areaGoodsNum < this.cardRule.selnum) {
                  this.$message({
                    type: 'error',
                    message: '专区可选择商品数量不能小于券卡可选择商品数量!'
                  });
                  return false
                }
                if (areaGoodsNum > this.cardRule.selnum) {
                  this.$message({
                    type: 'error',
                    message: '专区可选择商品数量不能大于券卡可选择商品数量!'
                  });
                  return false
                }
                let isTrue = true;
                this.cardRule.areainfo.some(item => {
                  if (item.listnum < item.zoneselnum) {
                    this.$message({
                      type: 'error',
                      message: `可选${item.zonename} 供选择商品数量不能小于可选择商品数量!`
                    });
                    isTrue = false;
                    return true
                  }
                })
                if (!isTrue) {
                  return false
                }
              }
            }
          }
          let subParams = {
            categorycode: this.goodsKind.categorycode,
            goodscode: this.goodsKind.goodscode,
            kindinfo: this.kindInfo.kindinfo,
            kindcontent: this.kindInfo.kindcontent,
            goodsprice: Number(this.kindInfo.goodsprice),
            goodsmallprice: Number(this.kindInfo.goodsmallprice),
            bexpresalegoods: this.specfyForm.supplyfor.indexOf('0') != -1 ? 1 : 0,
            isgift: this.specfyForm.supplyfor.indexOf('1') != -1 ? 1 : 0,
            bsale: this.kindInfo.bsale ? 1 : 0,
            kindpic: this.kindInfo.specImgUrl,
            showpos: this.kindInfo.showpos,
            channelinfo: this.channelInfo, // 取于状态管理器，销售渠道
            cardkindinfo: {
              cardkind: this.cardRule.cardkind,
              selnum: Number(this.cardRule.selnum),
              selzones: Number(this.cardRule.selzones),
              defaultgoodscode: this.cardRule.defaultgoodscode ? this.cardRule.defaultgoodscode : '0',
              defaultgoodsname: this.cardRule.defaultgoodsname,
              usenum: Number(this.cardRule.usenum),
              areainfo: this.cardRule.areainfo,
              bmodify: this.cardRule.bmodify, // 是否级联修改
            }
          }
          // if(this.cardRule.selzones == 1 && this.cardRule.defaultgoodscode&&this.cardRule.areainfo[0].optgoodscode.split(',').length>1) {
          //   let codeList = this.cardRule.areainfo[0].optgoodscode.split(',');
          //   let nameList = this.cardRule.areainfo[0].optgoodsname.split(',');
          //   let listnum = this.cardRule.areainfo[0].listnum - 1;
          //   let cardIndex = this.cardRule.areainfo[0].optgoodscode.indexOf(this.cardRule.defaultgoodscode);
          //   codeList.splice(cardIndex,1);
          //   nameList.splice(cardIndex,1);
          //   let codeInfo = codeList.join(',');
          //   let nameInfo = nameList.join(',');
          //   subParams.cardkindinfo.areainfo = [{
          //     optgoodscode: codeInfo,
          //     optgoodsname: nameInfo,
          //     zonename: this.cardRule.areainfo[0].zonename,
          //     listnum: listnum,
          //     zoneselnum: this.cardRule.areainfo[0].zoneselnum,
          //     sort: this.cardRule.areainfo[0].sort,
          //   }]
          // } else {
          //   subParams.cardkindinfo.areainfo = this.cardRule.areainfo;
          // }
          if (this.ElementControls('jinshizun') == 1 && this.ElementControls('saleordercontrprice') == 1) {
            subParams.directprice = Number(this.kindInfo.directprice);
            subParams.channelprice = Number(this.kindInfo.channelprice);
          }
          if (!this.postagefree && !this.bpinkage) {
            if (this.kindInfo.postageWeight !== '') {
              subParams.goodsweight = Number(this.kindInfo.postageWeight);
            } else {
              subParams.goodsweight = this.kindInfo.postageWeight;
            }
          }
          if (this.kindTabName != '新增') {
            subParams.kindcode = this.kindCode;
            // if(this.pinvcontrol && this.baseInvcontrol) {
            //   this.setInvinfo();
            // }
          }
          if (this.pinvcontrol && this.baseInvcontrol && this.kindTabName == '新增') {
            subParams.saleinv = Number(this.stockInfo.saleinv); //  库存
          };
          if (this.goodsKind.tcategorycode && this.goodsKind.tcategorycode != undefined) {
            subParams.tcategorycode = this.goodsKind.tcategorycode;
          }
          if (this.goodsKind.besale != 0) {
            subParams.electsmallprice = Number(this.kindInfo.electsmallprice);
          }
          if (!this.kindInfo.bsale) {
            subParams.unshelvememo = this.kindInfo.unshelvememo; // 下架备注
          }
          if (this.ElementControls('Goods_Pickupcard') == 1 && this.cardRule.cardcategory) {
            subParams.cardcategory = 0;
            subParams.cardkindinfo.goodspicknum = this.cardRule.goodspicknum;
            subParams.cardkindinfo.minpicknumonce = this.cardRule.minpicknumonce;
            subParams.cardkindinfo.defaultgoodscode = '0';
            subParams.cardkindinfo.defaultgoodsname = '';
          } else if (this.cardRule.tcCardcategory) {
            subParams.cardkindinfo.defaultgoodscode = '0';
            subParams.cardkindinfo.defaultgoodsname = '';
            Vue.set(subParams, 'cardcategory', 1)
            Vue.set(subParams.cardkindinfo, 'minpicknumonce', this.cardRule.minpicknumonce)
            subParams.cardkindinfo.areainfo = []
            let arry = []
            this.cardRule.arrylist.map((item, index) => {
              let Objects = {
                optgoodscode: item.kindcode,
                optgoodsname: item.goodsname + ' ' + item.kindinfo,
                zonename: '专区一',
                listnum: 1,
                sort: index+1,
                zoneselnum: item.remainnum,
                remainnum: item.remainnum
              }
              arry.push(Objects)
            })
            subParams.cardkindinfo.areainfo = arry
          } else if (this.cardRule.deCardcategory) {
            subParams.cardkindinfo.defaultgoodscode = '0';
            subParams.cardkindinfo.defaultgoodsname = '';
            Vue.set(subParams, 'cardcategory', 2)
          } else {
            subParams.cardcategory = null;
          }
          this.firstTrue = false;
          this.firstTrue = true;
          console.log(subParams, 'subParams')
          api.SAVEKINDINFO(subParams).then(res => {
            this.firstTrue = true;
            if (res.data.status == '200') {
              if (this.kindTabName == '新增') {
                sessionStorage.setItem('addSpecify', '1')
              }
              this.isAgain = true;
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.editKindInfo('', '新增');
              setTimeout(() => {
                this.isAgain = false;
              }, 0)
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          }).catch(res => {
            this.firstTrue = true;
          })
        }
      },
      // 设置库存的方法
      setInvinfo() {
        let setParams = {
          data: [
            {
              kindcode: this.kindCode,
              channeltype: 0,
              number: this.stockInfo.saleinv
            }
          ]
        };
        api.SETINVINFO(setParams).then(res => { })
      },
      // 获取商品详情信息
      getGoodsBase() {
        api.GOODS_BASICDETAIL({ goodscode: this.goodsCode }).then(res => {
          if (res.data.status == "200") {
            this.goodsKind = res.data.data;
            this.pinvcontrol = this.goodsKind.pinvcontrol ? true : false; // 是否控制库存
            this.postagefree = this.goodsKind.postagefree; // 商品是否包邮
            // 获取品牌详情
            if(this.goodsKind.brandcode) {
              api.GET_CARDSYSBASEINFO({brandcode: this.goodsKind.brandcode}).then(res => {
                if(res.data.status == "200") {
                  this.exchangemode = res.data.data.exchangemode
                }
              })
            }
            if (this.kindCode) {
              this.getKindDetail();
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      },
    },
    created() {

    },
    mounted() {
      sessionStorage.setItem('operateNotSaved','');
      if (this.$route.params.goodscode && this.$route.params.goodscode != '*') {
        this.goodsCode = this.$route.params.goodscode;
        this.getGoodsBase();
      };
      if (this.$route.query.kindcode) {
        this.kindDetail = '';
        this.kindCode = this.$route.query.kindcode;
        this.kindTabName = '编辑';
      }
      // 公共配置
      let pubordprintinfo = this.config.getPubordprintinfo();
      if (pubordprintinfo && pubordprintinfo != 'null') {
        this.baseInvcontrol = pubordprintinfo.invcontrol; // 商家是否开启库存控制
        if (!pubordprintinfo.bpinkage || !pubordprintinfo.thbpinkage) {
          this.bpinkage = 0; // 商家是否包邮
        } else {
          this.bpinkage = 1; // 商家是否包邮
        }
      }
    },
  }
</script>
<style scoped>
  @import '../Css/style.css';

  .salesChannelWrap>>>.el-col-24 .el-form-item__content {
    width: calc(100% - 100px);
    ;
    min-width: 200px;
    max-width: calc(100% - 100px);
  }

  /*规格信息*/
  .specTit {
    padding: 0 20px;
    background: #F5F7FA;
    line-height: 40px;
    color: var(--main-color);
    font-size: 16px;
  }

  .unitBox {
    position: relative;
  }

  .unitEm {
    position: absolute;
    right: -25px;
    color: #999;
  }

  /*规格配图*/
  .loadSpecImg {
    width: 120px;
    height: 120px;
    border: 1px dashed #CCC;
    background-color: #fbfdff;
    border-radius: 6px;
    cursor: pointer;
  }

  .loadSpecImg:hover {
    border-color: var(--main-color);
    transform: border-color .3s;
  }

  .loadSpecImg>>>.el-upload {
    position: relative;
    width: 120px;
    height: 120px;
    overflow: hidden;
  }

  .loadSpecImg .el-icon-upload {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -22px;
    margin-top: -22px;
    overflow: hidden;
    font-size: 44px !important;
    color: #C0C4CC !important;
  }

  .loadSpecImg>>>.el-upload img {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    margin: auto;
  }

  .useSetting>>>.el-form-item__content {
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 500px !important;
  }

  .useSetting .colorDanger {
    margin-right: 4px;
  }

  .warp {
    width: 100%;
  }

  .breathTit {
    margin-left: 15px;
  }

  .useSetting>>>.el-checkbox-group {
    display: inline-block;
  }

  .useSetting>>>.solono {
    margin-top: 40px;
  }
</style>


// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsGift/GoodsGiftSpecifyMange.vue